import React from 'react';
import './Header.css';
import { Avatar } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import SearchIcon from '@material-ui/icons/Search';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useStateValue } from '../../StateProvider';

function Header() {
  const [{ user }] = useStateValue();

  return (
    <div className='header'>
      <div className='header_left'>
        {/* Avatars for logged users nad Time icon */}
        <Avatar
          className='header_avatar'
          alt={user?.displayName}
          src={user?.photoURL}
        />
        <AccessTimeIcon />
      </div>
      <div className='header_search'>
        <SearchIcon />
        <input placeholder='search' type='text' />
      </div>
      <div className='header_right'>
        <HelpOutlineIcon />
      </div>
    </div>
  );
}

export default Header;
